// extracted by mini-css-extract-plugin
export var authorImage = "AboutMe-module--authorImage--bLuwt";
export var authorName = "AboutMe-module--authorName--A61Ew";
export var description = "AboutMe-module--description--sfYfG";
export var imageContainer = "AboutMe-module--imageContainer--Lqaby";